require('./Stamps.scss');

const React = require('react'),
    { PropTypes } = require('react');

const Stamps = React.createClass({displayName: "Stamps",
    propTypes: {
        maxVisible: PropTypes.number
    },

    render() {
        const { children } = this.props;

        const countStamps = React.Children.count(children);

        return (
            React.createElement("div", {"data-total-count": countStamps, className: "bp-stamps"}, 
                children
            )
        );
    }
});

module.exports = Stamps;



/** WEBPACK FOOTER **
 ** ./src/components/Commons/Stamps/Stamps.js
 **/